// extracted by mini-css-extract-plugin
module.exports = {"container":"daily_container__fgVd_","paper":"daily_paper__1xN4e"};